// Feel free to add data attribute here if you need
export type TTranslateFunc = (id: string) => string;
